import React from "react";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        height: "100vh",
    },
    image: {
        backgroundImage:
            "url(https://images.unsplash.com/photo-1530274083826-2facadf42457?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80%27)",
        backgroundRepeat: "no-repeat",
        backgroundColor: theme.palette.background.default,
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "justify",
    },
    copyrights: {
        position: "absolute",
        bottom: "5px",
    },
}));


export const TermsOfService = () => {
    const classes = useStyles();

    return (
        <Grid container component="main" className={classes.root}>
            <Grid item xs={false} sm={4} md={4} className={classes.image}/>
            <Grid item xs={12} sm={8} md={8} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <h1>Terms of Service</h1>
                    <p>Last updated: September 19, 2026</p>
                    <p>These Terms of Service ("Terms") govern your use of PlanPraise (the
                        "Service"). By creating an account or using the Service, you agree to
                        these Terms. If you don't agree, please don't use the Service.</p>

                    <h2>What PlanPraise Is</h2>
                    <p>PlanPraise is a tool for worship teams to plan events, organize their song
                        catalog, and propose and vote on new songs to learn. It's intended for use
                        by members of the worship teams that have set it up, not the general
                        public.</p>

                    <h2>Accounts</h2>
                    <p>You must provide an accurate email address to register, or sign in with a
                        supported third-party provider (Google or Microsoft). You're
                        responsible for keeping your account credentials secure and for activity
                        that happens under your account. The Service is not directed at children
                        under 13, and you must be at least 13 years old to use it.</p>
                    <p>To join a team, you'll need an invitation link from that team's admin, or an
                        admin will need to assign you to a team. Team leaders and admins have
                        additional capabilities (such as approving proposed songs, or editing
                        events) within their own team.</p>

                    <h2>Your Content</h2>
                    <p>When you propose a song, vote, or add event details, that content is
                        visible to other members of your own team - that's the point of the
                        Service. Please only submit content you have the right to share, and keep
                        it relevant to your team's use of the Service.</p>

                    <h2>Third-Party Services</h2>
                    <p>If you sign in with Google or Microsoft, your use of those
                        services is also governed by their own terms. If your team admin connects
                        the team to Spotify to auto-generate event playlists, that integration is
                        also subject to Spotify's terms; a team admin can disconnect it at any
                        time.</p>

                    <h2>Acceptable Use</h2>
                    <p>Please don't use the Service to upload unlawful, abusive, or infringing
                        content, attempt to disrupt or gain unauthorized access to the Service, or
                        use it for anything other than coordinating your worship team's songs and
                        events.</p>

                    <h2>Termination</h2>
                    <p>You can stop using the Service, disconnect linked social accounts, or
                        request deletion of your account at any time (see our <a
                            href="/privacy_policy">Privacy Policy</a> for details). We may suspend
                        or terminate access for accounts that violate these Terms.</p>

                    <h2>Disclaimer and Limitation of Liability</h2>
                    <p>The Service is provided "as is," without warranties of any kind. We do our
                        best to keep it running reliably, but we don't guarantee it will be
                        uninterrupted or error-free. To the extent permitted by law, we aren't
                        liable for indirect or consequential damages arising from your use of the
                        Service.</p>

                    <h2>Changes to These Terms</h2>
                    <p>We may update these Terms from time to time. Changes will be posted on this
                        page with an updated "Last updated" date. Continued use of the Service
                        after a change means you accept the updated Terms.</p>

                    <h2>Governing Law</h2>
                    <p>These Terms are governed by the laws of Norway, without regard to conflict
                        of law principles.</p>

                    <h2>Contact Us</h2>
                    <p>If you have any questions about these Terms, contact us:</p>
                    <ul>
                        <li>By email: filiphenriklarsen@gmail.com</li>
                        <li>By email: elraphah@gmail.com</li>
                    </ul>
                </div>
            </Grid>
        </Grid>
    );
};
